import { render } from "./AccountRemove.vue?vue&type=template&id=d06f4ed2"
import script from "./AccountRemove.vue?vue&type=script&lang=js"
export * from "./AccountRemove.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__